var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcHomeMenu012(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_19);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_19",
    x1: 0.43,
    y1: 0.43,
    x2: 198.09,
    y2: 198.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbf20"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_47",
    "data-name": "Trazado 47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.86,73.65H60.14a5.85,5.85,0,1,1,0-11.69h79.72a5.85,5.85,0,1,1,0,11.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_48",
    "data-name": "Trazado 48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.69,105.84H60.14a5.84,5.84,0,1,1,0-11.68h41.55a5.84,5.84,0,0,1,0,11.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_49",
    "data-name": "Trazado 49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.86,138H60.14a5.85,5.85,0,1,1,0-11.69h79.72a5.85,5.85,0,1,1,0,11.69Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHomeMenu012);
export default __webpack_public_path__ + "static/media/DC_Home_Menu_01 2.98c68cbecfd4563b1861aec5851e6c1a.svg";
export { ForwardRef as ReactComponent };